import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const createUnRegisteredClinic = createAsyncThunk(
  "/unRegisteredClinic/createUnRegisteredClinic",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/unRegisteredClinic/createUnRegisteredClinic",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const getAllUnRegisteredClinic = createAsyncThunk(
  "/unRegisteredClinic/getAllUnRegisteredClinic",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/unRegisteredClinic/getAllUnRegisteredClinic",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const updateUnregisteredClinic = createAsyncThunk(
  "/unRegisteredClinic/updateUnregisteredClinic",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        "/unRegisteredClinic/updateUnregisteredClinic",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const deleteUnRegisteredClinic = createAsyncThunk(
  "/unRegisteredClinic/deleteUnRegisteredClinic",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/unRegisteredClinic/deleteUnRegisteredClinic",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

const initialState = {
  loading: false,
  unRegisteredClinic: [],
  searchMessage: null,
  totalCount: 0,
  currentPage: 1,
  totalPages: 0,
  createUnRegisteredClinicSuccessMessage: null,
  createUnRegisteredClinicErrorMessage: null,
  updateUnregisteredClinicSuccessMessage: null,
  updateUnregisteredClinicErrorMessage: null,
  deleteUnRegisteredClinicSuccessMessage: null,
  deleteUnRegisteredClinicErrorMessage: null,
};

export const unRegisteredClinicSlice = createSlice({
  name: "unRegisteredClinic",
  initialState,
  reducers: {
    resetUnRegisteredClinicCreateMessage: (state) => {
      state.createUnRegisteredClinicSuccessMessage = null;
      state.createUnRegisteredClinicErrorMessage = null;
    },
    resetUnRegisteredClinicDeleteMessage: (state) => {
      state.deleteUnRegisteredClinicSuccessMessage = null;
      state.deleteUnRegisteredClinicErrorMessage = null;
    },
    resetUnRegisteredClinicUpdateMessage: (state) => {
      state.updateUnregisteredClinicSuccessMessage = null;
      state.updateUnregisteredClinicErrorMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createUnRegisteredClinic.pending, (state) => {
        state.loading = true;
        state.createUnRegisteredClinicSuccessMessage = null;
        state.createUnRegisteredClinicErrorMessage = null;
      })
      .addCase(createUnRegisteredClinic.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.createUnRegisteredClinicErrorMessage =
            action.payload.result.message;
        } else {
          state.createUnRegisteredClinicSuccessMessage =
            action.payload.result.message;
        }
      })
      .addCase(createUnRegisteredClinic.rejected, (state, action) => {
        state.loading = false;
        state.createUnRegisteredClinicErrorMessage =
          action.payload.result.message;
      })
      .addCase(getAllUnRegisteredClinic.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getAllUnRegisteredClinic.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.searchMessage = action.payload.result.message;
          state.unRegisteredClinic = [];
          state.totalCount = 0;
          state.totalPages = 0;
        } else {
          state.unRegisteredClinic = action.payload.result.list;
          state.totalCount = action.payload.totalCount;
          state.currentPage = action.payload.currentPage;
          state.totalPages = action.payload.totalPages;
          state.searchMessage = null;
        }
      })
      .addCase(getAllUnRegisteredClinic.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(updateUnregisteredClinic.pending, (state, action) => {
        state.loading = true;
        state.updateUnregisteredClinicSuccessMessage = null;
        state.updateUnregisteredClinicErrorMessage = null;
      })
      .addCase(updateUnregisteredClinic.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.updateUnregisteredClinicErrorMessage =
            action.payload.result.message;
        } else {
          state.updateUnregisteredClinicSuccessMessage =
            action.payload.result.message;
        }
      })
      .addCase(updateUnregisteredClinic.rejected, (state, action) => {
        state.loading = false;
        state.updateUnregisteredClinicErrorMessage =
          action.payload.result.message;
      })
      .addCase(deleteUnRegisteredClinic.pending, (state, action) => {
        state.loading = true;
        state.deleteUnRegisteredClinicSuccessMessage = null;
        state.deleteUnRegisteredClinicErrorMessage = null;
      })
      .addCase(deleteUnRegisteredClinic.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.deleteUnRegisteredClinicErrorMessage =
            action.payload.result.message;
        } else {
          state.deleteUnRegisteredClinicSuccessMessage =
            action.payload.result.message;
        }
      })
      .addCase(deleteUnRegisteredClinic.rejected, (state, action) => {
        state.loading = false;
        state.deleteUnRegisteredClinicErrorMessage =
          action.payload.result.message;
      });
  },
});

export const {
  resetUnRegisteredClinicCreateMessage,
  resetUnRegisteredClinicDeleteMessage,
  resetUnRegisteredClinicUpdateMessage,
} = unRegisteredClinicSlice.actions;

export default unRegisteredClinicSlice.reducer;
